import React from 'react';

import { useApiGet, useApiLoading } from 'react-reqq-lite';

import * as c from './constants';
import * as actions from './actions';

export const useGetProducts = (params, cb) => {
  const isApiLoading = useApiLoading(c.GET_PRODUCTS, 'get');
  const list = useApiGet(`${c.GET_PRODUCTS}.data`, []);
  const pagination = useApiGet(`${c.GET_PRODUCTS}.pagination`, {});

  React.useEffect(() => {
    if (params?.type === 'MERCHANT' && !params?.params?.branch_uuid) return;

    const $params = {
      ...params,
      params: {
        ...params?.params,
        categories: params?.params?.category?.value
          ? [params?.params?.category?.value]
          : undefined,
      },
    };

    actions.getProducts($params, cb);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)]);

  return [isApiLoading, list, pagination];
};

export const useGetSelectedProducts = (params) => {
  const isApiLoading = useApiLoading(c.GET_SELECTED_PRODUCT, 'get');
  const data = useApiGet(c.GET_SELECTED_PRODUCT, {});

  const refresh = React.useCallback(
    ($params, cb) => {
      if (params?.type === 'MERCHANT' && !params?.params?.branch_uuid) return;

      actions.getSelectedProducts(
        typeof $params === 'function' ? $params(params) : $params,
        cb
      );
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [JSON.stringify(params)]
  );

  return [isApiLoading, data, refresh];
};

export const useGenerateDraft = () => {
  const isApiLoading = useApiLoading(c.GENERATE_DRAFT, 'post');
  const data = useApiGet(`${c.GENERATE_DRAFT}.data`, {});

  const action = React.useCallback((params, cb) => {
    if (!params?.qrKey) return;

    actions.generateDraft(params, cb);
  }, []);

  return [isApiLoading, data, action];
};

export const useGetCategories = (params, cb) => {
  const isLoading = useApiLoading(c.GET_CATEGORIES, 'get');
  const list = useApiGet(`${c.GET_CATEGORIES}.data`, []);
  const pagination = useApiGet(`${c.GET_CATEGORIES}.pagination`, {});

  React.useEffect(() => {
    actions.getCategories(params, cb);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(params)]);

  return [isLoading, list, pagination];
};
